module.exports = __webpack_public_path__ + "static/img/new-14.1824d22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-14.png
// module id = RF5i
// module chunks = 0